import SubfactorHealthBadge from './SubfactorHealthBadge'
import * as constants from './subfactor-health-badge-constants'
import reducer from './subfactor-health-badge-reducer'

export {constants, reducer, SubfactorHealthBadge}
export default SubfactorHealthBadge
